import Photos from './photos'
import connect from './connect'

export default connect(Photos)
